import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Page from "@/page";
import LayoutPageRoute from "@/components/layout/layout-page-route.vue"; // 二级路由

Vue.use(VueRouter);

const routes = [
  
  // 重定向，首页列表
  {
    path: "/",
    redirect: "login",
    meta: { title: "国家药品追溯监管系统" },
    component: () => import("@/views/login/Index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/Index.vue"),
  },
  {
    path: "/sso-login",
    name: 'SsoLogin',
    component: () => import("@/views/home/Index.vue"),
  },
  {
    path: "/work",
    name: "Work",
    component: () => import("@/views/work/Index.vue"),
    meta: {
      title: "工作台",
    },
  },
  {
    path: "/page",
    component: Page,
    children: [
      // 日志管理
      {
        path: "logAdmin",
        name: "LogAdmin",
        component: LayoutPageRoute,
        children: [
          {
            path: "logSearch",
            name: "LogSearch",
            component: () => import("@/views/log-manage/log-search/Index.vue"),
            meta: {
              title: "日志查询",
            },
          },
          {
            path: "logTimeStatistics",
            name: "LogTimeStatistics",
            component: () =>
              import("@/views/log-manage/login-time-statistics/Index.vue"),
            meta: {
              title: "登录时间统计",
            },
          },
        ],
      },
      // 通知公告管理
      {
        path: "noticeAnnounce",
        name: "NoticeAnnounce",
        component: LayoutPageRoute,
        children: [
          {
            path: "noticeManage",
            name: "NoticeManage",
            component: () => import("@/views/notice-announce/notice-manage/Index.vue"),
            meta: {
              title: "通知公告管理",
            },
          },
        ],
      },
      // 应用管理
      {
        path: "appModule",
        name: "AppModule",
        component: LayoutPageRoute,
        children: [
          {
            path: "appManage",
            name: "AppManage",
            component: () => import("@/views/application-module/application-manage/Index.vue"),
            meta: {
              title: "应用管理",
            },
          },
        ],
      },
      // 系统管理
      {
        path: "sysManage",
        name: "SysManage",
        component: LayoutPageRoute,
        children: [
          {
            path: "roleManage",
            name: "RoleManage",
            component: () => import("@/views/sys-manage/role-manage/Index.vue"),
            meta: {
              title: "角色管理",
            },
          },
          {
            path: "userManage",
            name: "UserManage",
            component: () => import("@/views/sys-manage/user-manage/Index.vue"),
            meta: {
              title: "用户管理",
            },
          },
          {
            path: "adUserManage",
            name: "AdUserManage",
            component: () => import("@/views/sys-manage/admin-user-manage/Index.vue"),
            meta: {
              title: "管理员用户管理",
            },
          },
          {
            path: "orgManage",
            name: "OrgManage",
            component: () => import("@/views/sys-manage/org-manage/Index.vue"),
            meta: {
              title: "组织机构管理",
            },
          },
          {
            path: "departmentManage",
            name: "DepartmentManage",
            component: () => import("@/views/sys-manage/department-manage/Index.vue"),
            meta: {
              title: "部门管理",
            },
          },
        ],
      },
      // 刷新
      {
        path: "common",
        component: LayoutPageRoute,
        children: [
          {
            path: "refresh",
            name: "CommonRefresh",
            component: () => import("@/views/common/refresh.vue"),
            meta: {
              title: "refresh",
              keepAlive: false,
            },
          },
        ],
      },
    ],
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach(async (to, from, next) => {
  const menu = store.getters["platMainMenus"].find(
    (item) => item.link === to.path
  );
  let componentObj = {};
  componentObj = to.matched.slice(-1)[0];

  let tab = {
    id: to.path,
    title: menu ? menu.authName : to.meta.title,
    path: to.path,
    name: componentObj.name,
    url: to.fullPath,
  };
  // 已存在的tab 如果fullpath发生变动，则移除
  const existTab = store.state.tabs.tabs.find((item) => item.name === tab.name);
  if (existTab && existTab.url !== tab.url) {
    store.commit("tabs/removeTabByName", tab.name);
    store.commit("tabs/setExcludeTabs", [tab.name]);
  }
  if (to.name !== "CommonRefresh") {
    store.commit("tabs/selectTab", tab);
  }
  next();
});
router.afterEach((to, from) => {
  if (from.name === "CommonRefresh") {
    store.commit("tabs/setExcludeTabs");
  } else {
    const componentName = to.matched.slice(-1)[0].components.default.name;
    // 通过fullPath 参数变化 刷新已存在的页面(更新key但不会更新路由缓存 缓存由store-tabs更新)
    if (store.getters["tabs/tabNames"].includes(componentName)) {
      if (
        !store.state.tabs.tabs.find((tab) => tab.url === to.fullPath) &&
        to.name !== "CommonRefresh"
      ) {
        store.commit("tabs/setExcludeTabs", [componentName]);
        router.push({
          name: "CommonRefresh",
        });
      }
    }
  }
});

export default router;
export { LayoutPageRoute };
